import type { ConditionConfig, FilterGroupItem } from '@lighthouse/shared'
import React, { Fragment } from 'react'

import * as CM from '../styles'
import * as SC from './styles'

type ConditionCardProps = {
    config: ConditionConfig
}
const conditionName = (index: number) => {
    if (index === 0) {
        return '如果'
    }
    return '否则如果'
}

const conditionCount = (filter: FilterGroupItem) => {
    const num = filter?.filter?.expression?.conditions?.length || 0

    return num ? `已设置${num}个条件` : '未设置条件'
}

const ConditionCard: React.FC<ConditionCardProps> = ({ config }) => {
    const { filterGroup } = config

    if (!filterGroup || filterGroup.length === 0) {
        return null
    }
    return (
        <CM.CardContainer>
            {filterGroup.map((filter, index) => {
                return (
                    <CM.CardItemContainer key={filter.id}>
                        <SC.ItemHeader>
                            <SC.TypeName>情况{index + 1}</SC.TypeName>
                            <SC.IfElse>{conditionName(index)}</SC.IfElse>
                        </SC.ItemHeader>
                        <CM.FieldItem>
                            <CM.FieldItemTitle>{conditionCount(filter)}</CM.FieldItemTitle>
                        </CM.FieldItem>
                    </CM.CardItemContainer>
                )
            })}
            <CM.CardItemContainer>
                <SC.ItemHeader>
                    <SC.TypeName>情况{filterGroup.length + 1}</SC.TypeName>
                    <SC.IfElse>否则</SC.IfElse>
                </SC.ItemHeader>
            </CM.CardItemContainer>
        </CM.CardContainer>
    )
}

export default ConditionCard
